import { Modal } from "react-bootstrap";
import { Spinner } from "react-bootstrap";
export const Boxnotification = (props) => {
    return (
        <div style={{ width: '100%' }}>
            <Modal show={props.openingDeactivate} onHide={props.handleCloseReduces_usage} style={{ paddingTop: 50 }} >
                <Modal.Header closeButton>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',

                        width: '100%'


                    }}>
                        <small style={{ fontWeight: 'bold', fontSize: 20 }}>Deativate this account?</small>
                    </div>
                </Modal.Header>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: 10,
                    marginLeft: 10
                }}>
                    <small style={{ marginTop: 40, fontSize: 18 }}>Are you sure you want to make ( {props.inactive} ) Inactive.</small>
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    marginBottom: 20,
                    marginLeft: 10
                }}>
                    <div style={{
                        backgroundColor: '#0d6efd',
                        marginRight: 20,
                        borderRadius: 5,
                        height: 30,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer'
                    }}
                        onClick={() => { props.handleCloseReduces_usage() }}
                    >
                        <small style={{ fontSize: 14, marginLeft: 20, marginRight: 10, fontWeight: 'bold', color: 'white' }}>

                            No

                        </small>
                    </div>
                    <div style={{
                        backgroundColor: '#0d6efd',
                        marginRight: 20,
                        borderRadius: 5,
                        height: 30,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer'
                    }}
                        onClick={() => { props.Delete_Department(props.inactive_id) }}
                    >
                        <small style={{ fontSize: 14, marginLeft: 20, marginRight: 10, fontWeight: 'bold', color: 'white' }}>

                            {!props.isLoading_reduces ? (
                                <>
                                    Make Inactive
                                </>
                            ) : (
                                <>
                                    {
                                        <Spinner animation="border" variant="light" size='sm' />
                                    }
                                </>)
                            }

                        </small>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
